export default class {
  restart() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    this.update();
    this.interval = setInterval(() => requestAnimationFrame(this.update.bind(this)), 1000);
  }

  update() {
    const timers = document.querySelectorAll('time[datetime]');
    const now = new Date().getTime();

    for (const timer of timers) {
      const format = timer.dataset.format ?? 'long';
      const distance = new Date(timer.getAttribute('datetime')).getTime() - now;
      const hasEndingBlock = timer.classList.contains('has-ending-block');

      let days, hours, minutes, seconds;
      if (distance <= 0) {
        days = hours = minutes = seconds = 0;
      } else {
        days = Math.floor(distance / (1000 * 60 * 60 * 24));
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        seconds = Math.floor((distance % (1000 * 60)) / 1000);
      }

      let text = '';

      if (format === 'long' && distance > 0) {
        text = `${seconds} sec`;
        if (minutes > 0) {
          text = `${minutes} min en ${text}`;
        }
        if (hours > 0) {
          text = `${hours} uur, ${text}`;
        }
        if (days > 0) {
          text = `${days}d, ${text}`;
        }
      } else if (format === 'short') {
        text = `${days}d ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }

      if (hasEndingBlock) {
        timer.querySelector('.active-block').innerText = text;
      } else {
        timer.innerText = text;
      }

      if (timer.classList.contains('invisible')) {
        timer.classList.remove('invisible');
      }

      if (distance <= 0) {
        timer.classList.remove('one-minute-left', 'ten-seconds-left');

        timer.classList.add('timer-has-ended');
        timer.classList.remove('timer-is-active');
      }
      else if (distance / 1000 >= 60) {
        timer.classList.remove('one-minute-left', 'ten-seconds-left');

        timer.classList.remove('timer-has-ended');
        timer.classList.add('timer-is-active');
      }
      // Less than 10 seconds remaining
      else if (distance / 1000 < 10 && !timer.classList.contains('ten-seconds-left')) {
        timer.classList.add('ten-seconds-left');
      }
      // Less than 1 minute remaining
      else if (distance / 1000 < 60 && !timer.classList.contains('one-minute-left')) {
        timer.classList.add('one-minute-left');
      }
    }
  }
}
